<template>
    <div>
        <Backer v-if="showbacker != false" />

        <!-- <div style="font-size: 20px; display: inline-block; margin: 10px; font-weight: bold;">Generate Pullist - Store Transfers</div> -->

        <div class="" >
            <b-overlay :show="trs_being_loaded" rounded="sm">
                <div style="min-width: 700px;">
                    <b-alert show variant="warning" v-if="transfer_requests.length <= 0">
                        No Transfer Requests
                    </b-alert>
                    <div v-else>

                        <div style="background: #e28158; padding: 10px; margin-bottom: 10px; color: white; font-size: 15px; font-weight: bold;">
                            <div style="display: inline-block;">
                                PULL LOCATION: 
                                <b-form-select 
                                    style="width: 180px;"
                                    v-on:change="setPullLocation"
                                >
                                    <b-form-select-option v-for="location in locations" :value="location.value" v-if="source_locations_counts[location.value]" v-bind:key="value">{{ location.text }} ({{source_locations_counts[location.value]}} items)</b-form-select-option>
                                </b-form-select>
                            </div>

                             <div style="display: inline-block; margin-left: 20px;">
                                FILTER: 
                                <b-form-select 
                                    style="width: 180px;"
                                    v-on:change="filterItems"
                                    :disabled="picked_location == null"
                                >
                                    <b-form-select-option value="">ALL</b-form-select-option>
                                    <b-form-select-option value="sales_only">STORE SALES ONLY</b-form-select-option>
                                    <b-form-select-option value="store_transfers_only">STORE TRANSFERS ONLY</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div v-if="picked_location" style="text-align: center; margin-top:10px; background: white; width: 100%;  padding: 10px; min-width: 700px;">
                                    <b-card
                                        
                                        style="min-width: 700px;"
                                    >
                                        <table style="width: 100%">
                                            <thead>
                                                <tr style="background: black; color: white;">
                                                    <td class="ipt_tdhr">
                                                        NAME
                                                    </td>
                                                    <td class="ipt_tdhr">
                                                        # ITEMS
                                                    </td>
                                                    <td class="ipt_tdhr">
                                                        PULL DATE
                                                    </td>
                                                    <td class="ipt_tdhr">
                                                        DELIVERY DATE
                                                    </td>
                                                   <!--  <td class="ipt_tdhr">
                                                        TRUCK
                                                    </td> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="ipt_tdr" style="padding: 5px; background: #ffe8cc;">
                                                        <b-input size="sm" v-model="pullist_name" autocomplete="off" style="font-size: 13px; width: 250px;"></b-input>
                                                    </td>
                                                    <td class="ipt_tdr" style="padding: 5px; background: #ffe8cc; color: red;">
                                                        <b>{{ (selected_items.length || 0) }}</b>
                                                    </td>
                                                    <td class="ipt_tdr" style="padding: 5px; background: #ffe8cc;">
                                                        <b-form-datepicker 
                                                            v-model="pull_date"
                                                            reset-button
                                                            style="font-size: 13px; margin: auto;"
                                                            size="sm" placeholder="Pull Date"
                                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" 
                                                            locale="en-US">
                                                        </b-form-datepicker>
                                                    </td>
                                                    <td class="ipt_tdr" style="padding: 5px; background: #ffe8cc;">
                                                        <b-form-datepicker 
                                                            v-model="delivery_date"
                                                            reset-button
                                                            style="font-size: 13px; margin: auto;"
                                                            size="sm" placeholder="Delivery Date"
                                                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" 
                                                            locale="en-US">
                                                        </b-form-datepicker>
                                                    </td>
                                                    <!-- <td class="ipt_tdr" style="padding: 5px; background: #ffe8cc;">
                                                        <b-input size="sm" v-model="truckname" autocomplete="off"></b-input>
                                                    </td> -->
                                                </tr>
                                            </tbody>
                                        </table>

                                        <b-button size="sm" variant="success" style="font-weight: bold; margin: 10px;" @click="triggerSavePullist" :disabled="selected_items.length <= 0">Create Pullist</b-button>
                                    </b-card>

                            </div>
                        </div>
                        <table style="width: 100%;">
                            <thead>
                                <tr style="background: #efefef;">
                                    <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                        RQSTR
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('request_date')">
                                        NEED ON
                                    </td>
                                    <td class="ipt_tdhr">
                                        PRD ID
                                    </td>
                                    <td class="ipt_tdhr">
                                        PRODUCT
                                    </td>
                                    <td class="ipt_tdhr">
                                        QTY
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('source_location_id')">
                                        FROM
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                        TO
                                    </td>
                                    <td class="ipt_tdhr hidden-print" v-on:click="sortby('status')">
                                        STATUS
                                    </td>
                                    <td class="ipt_tdhr hidden-print">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="tritem, idx in transfer_requests" :style="{'border': ((active == idx) ? '3px solid black' : 'inherit'), 'background': ((get_item_key(tritem) in selected_items_dict) ? '#f4ffcd' : 'inherit')  }" v-if="allow_row(idx)" v-bind:key="product_id">
                                    <td class="ipt_tdr">
                                        {{ locationsdict[tritem.location_id] }}
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ tritem.request_date }}
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ tritem.product_id }}
                                    </td>

                                    <td class="ipt_tdr">
                                        <div style="font-weight: bold; padding: 4px;">{{ tritem.product_sku }}</div>
                                        <div>{{ tritem.vendor }} ( {{ tritem.category }})</div>
                                        <b-badge v-if="tritem.invoice_id != null" variant="success">sale # {{ tritem.invoice_id}}</b-badge>
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ tritem.approved_quantity }}
                                    </td>

                                    <td class="ipt_tdr">
                                        <div>{{ locationsdict[transfer_requests[idx].source_location_id] }}</div> 
                                        <div>{{ sublocationsdict[transfer_requests[idx].source_sublocation_id] }}</div>
                                    </td>

                                    <td class="ipt_tdr">
                                        <div>{{ locationsdict[transfer_requests[idx].location_id] }}</div>
                                        <div>{{ sublocationsdict[transfer_requests[idx].sublocation_id] }}</div>
                                    </td>

                                    <td class="ipt_tdr hidden-print" :style="{'background-color': tr_item_statuses_colors[tritem.status]}">
                                        {{ tr_item_statuses_dict[tritem.status] }}
                                    </td>

                                    <td class="ipt_tdr hidden-print">
                                        <span v-if="existsInPullist(idx)">
                                            <b-button size="sm" variant="warning" @click="removeFromPullist(idx)" style="font-size: 11px;" >DROP</b-button>
                                        </span>

                                        <span v-else>
                                            <b-button size="sm" @click="addToPullist(idx)" style="font-size: 11px;" v-if="picked_location">SELECT</b-button>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        
                    </div>
                </div>
            </b-overlay>
            
            <b-modal id="modal-availability" scrollable title="" size="md" hide-footer>
                <Availability :viewdata="{availability_data:availability_data, product_id: q_product_id, product_sku: q_product_sku}" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
            </b-modal>
        </div>

    </div>

</template>

<script>
    import moment from 'moment'
    import global_vars from "@/utilities/global_vars"
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Availability from '@/components/importables/Availability'

    export default {
        name: "MyRequests",
        props: ["showbacker"],
        components: {Backer, Availability},
        data: function(){
            let out = {
                userDetails: {properties: {}},
                request_types: [
                    {value: "transfer_for_display", text: "Store Transfer (for display)"},
                    {value: "transfer_for_pickup", text: "Store Transfer (for store pickup)"},
                    {value: "transfer_for_storage", text: "Store Transfer (for storage)"},
                    {value: "transfer_for_delivery", text: "Customer Transfer (for customer delivery)"}
                ],
                request_types_dict: {
                    transfer_for_display: {text: "Display", color: "green"},
                    transfer_for_storage: {text: "Storage", color: "cornflowerblue"},
                    transfer_for_delivery: {text: "Customer Delivery", color: "red"},
                    transfer_for_pickup: {text: "Store Pickup", color: "blue"}
                },
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                tr_status: null,
                tr_item_statuses: global_vars.TRANSFER_STATUSES,
                tr_item_statuses_colors: global_vars.TRANSFER_STATUSES_COLORS_DICT,
                tr_item_statuses_dict: global_vars.TRANSFER_STATUSES_DICT,

                inventory_sources: {},
                trs_being_loaded: true,
                transfer_requests:[],
                item_being_reserved: false,
                availables: {},
                display_tr_with_status: null,
                buffered: {},
                is_action_disabled: false,
                availability_data: [],
                q_product_id: null,
                q_product_sku: null,
                active: null,
                sort_asc: true,
                picked_location: null,
                selected_items: [],
                selected_items_dict: {},
                locsubs: [],
                all_loc_inventory_dict: {},
                pullist_name: null,
                pull_date: null,
                delivery_date: null,
                truckname: null,
                source_locations_counts: {},
                filter_value: null,
            };
            return out;
        },
        methods: {
            filterItems: function(value){
                if (value){
                   this.filter_value = value; 
                   console.log(this.filter_value)
                }
                else {
                    this.filter_value = null;
                }  
            },
            allow_row: function(idx){
                let item = this.transfer_requests[idx];

                if (item.source_location_id == this.picked_location){
                    if (this.filter_value == null){
                        return true
                    }
                    else {
                        if (this.filter_value == 'sales_only'){
                            if (item.invoice_id != null){
                                return true
                            }
                            else {
                                return false
                            }
                        }
                        else if (this.filter_value == 'store_transfers_only'){
                            if (item.invoice_id == null){
                                return true
                            }
                            else {
                                return false
                            }
                        }
                    }
                }
                else {
                    false
                }
            },
            setPullLocation: function(location){
                this.picked_location = location;
                this.selected_items = [];
                this.selected_items_dict = {};
                this.pullist_name = this.get_pullist_name()
            },
            get_item_key: function(item){
                return JSON.stringify(item.location_id)+JSON.stringify(item.product_id)+JSON.stringify(item.product_sku)+JSON.stringify(item.tr_id)+JSON.stringify(item.itemid);
            },
            existsInPullist: function(idx){
                let item = this.transfer_requests[idx];
                let itemkey = this.get_item_key(item);
                if (this.selected_items_dict[itemkey]){
                    return true
                }
                else {
                    return false
                }
            },
            removeFromPullist: function(idx){
                let item = this.transfer_requests[idx];
                let itemkey = this.get_item_key(item);
                let that = this;
                this.selected_items = this.selected_items.filter(function(d){
                    return that.get_item_key(d) != itemkey
                });
                this.selected_items_dict = this.selected_items.reduce((map, obj) => (map[that.get_item_key(obj)] = true, map), {});
            },
            addToPullist: function(idx){
                if (this.picked_location == null){
                    this.$vex.dialog.alert({message: "Please select a location first to start building the pullist."});
                    return
                }
                let item = this.transfer_requests[idx];
                let itemkey = this.get_item_key(item)
                let exists = this.selected_items_dict[itemkey]
                if (exists){
                    this.$bvToast.toast(
                        "Item already exists", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                this.selected_items.push(item)
                this.selected_items_dict[itemkey] =true;

            },
            updateTRItem: function(idx){
                let that = this;
                let path = "/api/inventory/update_tr_item_st_tran/"
                let data = this.transfer_requests[idx];
                if (data.locsub) {
                    let splitted = data.locsub.split("|").map(function(d){ return +d });
                    if (splitted.length > 1){
                        data.source_location_id = splitted[0];
                        data.source_sublocation_id = splitted[1];
                    }
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Updated TR Item.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred while updating TR Item. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                                        {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name, description: d.description}
                                });

                                
                                if (that.userDetails){
                                    if (that.userDetails.properties){
                                        if (that.userDetails.properties.location_id){
                                            let location_id = that.userDetails.properties.location_id;

                                            that.locations = that.locations.filter(function(d){return d.value == location_id });
                                            that.invoice.location_id = location_id;
                                        }
                                    }
                                }

                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id, sublocation_type_id: d.sublocation_type_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                                that.vendors = response.data.result.vendors.map(function(d){
                                    return {value: d.value, text: d.text}
                                });
                                that.vendorsdict = that.vendors.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.locsubs = response.data.result.locsubs;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response) {
                            if (response.data.result){
                                that.all_loc_inventory_dict = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error) {
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/inventory/get_open_tr_items/",
                        data: {userid: this.userDetails.id, tr_statuses: [1]},
                        type: "secure",
                        executable: Requestor.postSyncP,
                        s: function(response){
                            if (response.data.result){
                               that.transfer_requests = response.data.result;
                               that.transfer_requests.forEach(function(d){
                                    let approved_quantity = d.approved_quantity;
                                    let source_location_id = d.source_location_id;
                                    if (that.source_locations_counts[source_location_id]){
                                        that.source_locations_counts[source_location_id] += 1
                                    }
                                    else {
                                        that.source_locations_counts[source_location_id] = 1
                                    }
                               })
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                            that.trs_being_loaded = false;
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading transfer requests.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            that.trs_being_loaded = false;
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            validateItemsForPullist: function(pullist_data){
                let errors = [];
                if (pullist_data.length <= 0){
                    errors.push("Cannot save an empty pullist.");
                }
                let locations_involved = {}
                for (var i=0; i<pullist_data.length; i++){
                    if ((pullist_data[i].source_location_id ==null) || (pullist_data[i].source_sublocation_id ==null) ) {
                        errors.push("Please assign source locations to all the items.")
                        break
                    }

                    if (isNaN(parseInt(pullist_data[i].approved_quantity))){
                        errors.push("Valid approved quantities needed for all items.")
                        break
                    }

                    //locations_involved[pullist_data[i].location_id] = true
                }

                // if (Object.keys(locations_involved).length > 1) {
                //     errors.push("Cannot generate pullist involving multiple destination locations.")
                // }

                return errors;
            },
            get_pullist_name: function(){
                if (this.picked_location){
                    let location_name = this.locationsdict[this.picked_location].toUpperCase().replace(" ", "_");
                    let pullist_name = location_name +"_"+ (moment().format("MMDDYYYYHHmm"));
                    return pullist_name
                }
                else {
                    return null
                }
            },
            triggerSavePullist: function(e){
                let that = this;

                if (this.selected_items.length == 0){
                    this.$vex.dialog.alert({message: "Please add items for this destination."});
                    return
                }

                if (!this.pullist_name){
                    this.$vex.dialog.alert({message: "Please enter a name for this pullist."});
                    return
                }

                if (!this.pull_date){
                    this.$vex.dialog.alert({message: "Please enter an expected pull date."});
                    return
                }

                if (!this.delivery_date){
                    this.$vex.dialog.alert({message: "Please enter an expected delivery date."});
                    return
                }

                this.$vex.dialog.confirm({
                    message: "Saving this pullist will mark these items to be pulled from their locations and shipped. Continue?",
                    className: 'vex-theme-os',
                    callback: function (value) {
                        if (value){
                            that.savePullist();
                        }
                    }
                })

            },
            savePullist: function(e) {
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let trs = this.selected_items;

                if (trs.length == 0){
                    this.$bvToast.toast(
                        "Cannot save empty pullist.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                let errors = this.validateItemsForPullist(trs);
                if (errors.length > 0) {
                    this.$bvToast.toast(
                        errors[0], 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                //if all good, go ahead and save tr.
                let path = "/api/inventory/save_pullist/"
                let data = {};
                data.items = trs.map(function(d){
                    return {
                        tr_id: d.tr_id, 
                        itemid: d.itemid, 
                        product_id: d.product_id, 
                        product_sku: d.product_sku, 
                        vendor: d.vendor, 
                        category: d.category, 
                        source_location_id: d.source_location_id, 
                        source_sublocation_id: d.source_sublocation_id, 
                        requested_quantity: parseInt(d.requested_quantity),
                        approved_quantity: parseInt(d.approved_quantity), 
                        
                    }
                });
                data.name = this.pullist_name;
                data.pull_date = this.pull_date;
                data.delivery_date = this.delivery_date;
                data.truckname = this.truckname;

                let s = function(response) {
                    that.trs_being_loaded = false;
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$router.go();
                        that.trs_being_loaded = false;
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred while saving the pullist. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.trs_being_loaded = false;
                }

                this.trs_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            getTRItemAvailability: function(idx){

                this.active = idx;
                let path = "/api/inventory/get_tr_item_availability/";
                let item = this.transfer_requests[idx];
                let data = {product_id: item.product_id, product_sku: item.product_sku};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.availability_data = response.data.result;
                        that.q_product_id = item.product_id;
                        that.q_product_sku = item.product_sku;
                        that.$bvModal.show("modal-availability");
                    }
                    that.is_action_disabled = false
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "An error occurred trying to fetch product availability. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.is_action_disabled = false
                }
                this.is_action_disabled = true;
                Requestor.getAsync(path, data, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.transfer_requests = Requestor.sort(this.transfer_requests, key)
                }
                else {
                    this.transfer_requests = Requestor.sort_reverse(this.transfer_requests, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14px;
        background: #e5ffb1;
    }

    td {
        padding: 1px;
        background: inherit;
        font-size: 14px;
    }

    select {
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/GeneratePullist.vue